import { ConfirmModal } from '../../../components/modal/confirm-modal/ConfirmModal.component';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import '../daily-fee.styles.scss';
import { useIsAllowed } from '../../../utils/useCurrentUser';

export default function ReportsModal({ isOpen, closeModal }) {
  const { isAllowed } = useIsAllowed();

  const history = useHistory();

  const actions = [
    ...(isAllowed([
      'DailyBillingFeesReportAccess',
      'DailyBillingFeesReportAccessReadOnly',
    ])
      ? [
          {
            id: 'student-statement-report',
            text: 'Student Statement',
          },
          {
            id: 'daily-summary-report',
            text: 'Daily Summary Report',
          },
          {
            id: 'daily-reconciliation-report',
            text: 'Daily Reconciliation Report',
          },
          {
            id: 'student-arrears-report',
            text: 'Student Arrears & Deposit Report',
          },
        ]
      : []),
    ...(isAllowed([
      'DailyBillingFeesStudentBillAccess',
      'DailyBillingFeesStudentBillAccessReadOnly',
    ])
      ? [
          {
            id: 'student-bills-report',
            text: 'Student Bills Report',
          },
        ]
      : []),
  ];

  return (
    <ConfirmModal
      title="Daily Fee Reports"
      isOpen={isOpen}
      closeModal={closeModal}
      secondaryActionText="Close"
      secondaryBtnClasses="secondary"
      description={
        <>
          <p className="text-label">Click to view a daily fee report.</p>
          <div className="mt-30" style={{ display: 'grid', gap: '20px' }}>
            {actions.map((action) => (
              <button
                key={action.id}
                className="clean-btn text-primary text-left"
                onClick={(e) => {
                  history.push(`/daily-fees/${action.id}`);
                  e.target.blur();
                  closeModal();
                }}
              >
                {action.text}
              </button>
            ))}
          </div>
        </>
      }
    />
  );
}
